const dismissPartial = partial => {
    partial.remove();

    axios.post('/actions/dismissPartial', {
        partialId: partial.id
    }).then(response => {
        //
    });
};

const partials = document.getElementsByClassName('partial');

[].forEach.call(partials, partial => {
    const dismissButtons = partial.getElementsByClassName('partial-dismiss');

    [].forEach.call(dismissButtons, dismissButton => {
        dismissButton.addEventListener('click', event => {
            event.preventDefault();
            dismissPartial(partial);
        });
    });
});
